/**
 * Pure cycle-count helpers extracted from CycleCount.tsx so the submit math is
 * unit-tested independently of the screen.
 */

/** Inventory adjustment sent to `completeCycleCount/{taskId}/{delta}`. */
export function cycleCountDelta(counted: number, expected: number): number {
  return counted - expected;
}

/** Expected total across the tasks at a static slot. */
export function staticTotalQuantity(
  tasks: Array<{ cycleCountTask?: { expectedQuantity?: number } }>
): number {
  return tasks.reduce(
    (sum, task) => sum + (task.cycleCountTask?.expectedQuantity ?? 0),
    0
  );
}

/**
 * The client-side half of scan validation (CycleCount.tsx:479-488): the scanned
 * bin and SKU must be non-empty and equal the task's expected values before the
 * BinMaster/MasterData existence calls are made.
 */
export function matchesExpectedIdentifiers(
  binId: string,
  skuId: string,
  expectedBinId: string,
  expectedSkuId: string
): boolean {
  const trimmedBinId = binId.trim();
  const trimmedSkuId = skuId.trim();
  if (!trimmedBinId || !trimmedSkuId) {
    return false;
  }
  return (
    trimmedBinId === expectedBinId.trim() &&
    trimmedSkuId === expectedSkuId.trim()
  );
}

/** A whole-number quantity string (used by the static total field). */
export function isValidQuantityInput(value: string): boolean {
  return /^\d+$/.test(value.trim());
}
